import { defineStore } from 'pinia';
import { scriptLoader } from '~/utils/scriptLoader';

export const useStoreMatch2One = defineStore('match2one', {
  actions: {
    async loadUniversalScript() {
      try {
        await scriptLoader('https://acdn.adnxs.com/dmp/up/pixie.js', 'match2one');
        setTimeout(() => {
          this.trigger('PageView');
        }, 1000);
      } catch (e) {
        console.error(e);
      }
    },
    trigger(eventName: string, payload?: Record<string, any>) {
      if (!payload) {
        // @ts-ignore
        pixie('event', eventName);
      } else {
        // @ts-ignore
        pixie('event', eventName, payload);
      }
    },
  },
});
